import certification from "public/pocCloud/certification-labs.jpg";
import { ListWithLabel } from "@/components/list";

export const INTRO_CONSTANTS = {
  title: "Certification Labs, Designed for Real-World Readiness",
  description: [
    "OneMind’s Certification Labs provide fully virtualized, on-demand environments tailored for IT professionals preparing for industry-standard certifications. Built to mirror real-world network and system scenarios, these labs deliver hands-on experience in a secure, scalable cloud infrastructure.",
    "Whether you're training for Cisco, CompTIA, Microsoft, or other key certifications, our labs are designed to accelerate learning, reinforce skills, and build confidence—without requiring physical hardware.",
  ],
  children: (
    <ListWithLabel
      points={[
        {
          label: "Industry-Standard Certification Environments",
          text: "Labs are purpose-built to align with real exam objectives, covering the exact technologies and workflows tested by certification bodies.",
        },
        {
          label: "Fully Virtualized & Scalable Infrastructure",
          text: "No hardware required. Access dynamic, cloud-hosted environments from anywhere, with the ability to scale resources as needed.",
        },
        {
          label: "On-Demand Access for Training & Upskilling",
          text: "Train at your pace, repeat scenarios as needed, and upskill without the limitations of a classroom or physical lab.",
        },
        {
          label: "Ideal for Enterprises, Educators & Individuals",
          text: "Perfect for corporate training programs, academic institutions, or individuals preparing for their next career milestone.",
        },
      ]}
    />
  ),
  image: certification,
  imageHeight: "450px",
};
